function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:none}.cls-1{stroke:#2a343f;stroke-width:2px}.cls-2{stroke:none}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3266",
  "data-name": "Group 3266",
  transform: "translate(-32.999 -1080.711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3209",
  "data-name": "Group 3209",
  transform: "translate(33 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3262",
  "data-name": "Group 3262",
  transform: "translate(33 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-2",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .162)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3265",
  "data-name": "Group 3265",
  transform: "translate(33 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-3",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .324)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3258",
  "data-name": "Group 3258",
  transform: "translate(43 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-4",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3261",
  "data-name": "Group 3261",
  transform: "translate(43 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-5",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .162)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3264",
  "data-name": "Group 3264",
  transform: "translate(43 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-6",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .324)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3259",
  "data-name": "Group 3259",
  transform: "translate(53 1100.711)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-7",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3260",
  "data-name": "Group 3260",
  transform: "translate(53 1090.549)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-8",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .162)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3263",
  "data-name": "Group 3263",
  transform: "translate(53 1080.386)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351-9",
  "data-name": "Rectangle 351",
  className: "cls-1",
  transform: "translate(-.001 .324)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: 6,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1 1h4v4H1z"
}))));

function SvgAppsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps-icon.6012254e.svg";
export { ForwardRef as ReactComponent };